/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCoffin = createReactComponent("coffin", "IconCoffin", [
  ["path", { d: "M7 3l-2 6l2 12h6l2 -12l-2 -6z", key: "svg-0" }],
  ["path", { d: "M10 7v5", key: "svg-1" }],
  ["path", { d: "M8 9h4", key: "svg-2" }],
  ["path", { d: "M13 21h4l2 -12l-2 -6h-4", key: "svg-3" }]
]);

export { IconCoffin as default };
//# sourceMappingURL=IconCoffin.js.map
